import CustomState from '@rio-cloud/rio-uikit/CustomState';
import { FormattedMessage } from 'react-intl';

const MileageBelow20KKmErrorState = () => {
    return (
        <CustomState
            headline={<FormattedMessage id="intl-msg:batteryService.error.historyAvailableSoon" />}
            message={<FormattedMessage id="intl-msg:batteryService.stateOfHealth.availableAfterCollecting.reason" />}
            icons={[
                {
                    name: 'rioglyph rioglyph-time',
                },
            ]}
        />
    );
};

export default MileageBelow20KKmErrorState;
